export default class ObjectUtils {
    static unflatten(flattenedObject) {
        const result = {}
        for (let i in flattenedObject) {
            let keys = i.split('|')
            keys.reduce(function (r, e, j) {
                return r[e] || (r[e] = isNaN(Number(keys[j + 1])) ? (keys.length - 1 === j ? flattenedObject[i] : {}) : [])
            }, result)
        }
        return result;
    }

    static flatten(data, c) {
        var result = {}
        for (var i in data) {
            if (typeof data[i] == 'object') Object.assign(result, ObjectUtils.flatten(data[i], c + '|' + i))
            else result[(c + '|' + i).replace(/^\|/, "")] = data[i]
        }
        return result
    }

    static getKeyByValue(object, value) {
        return Object.keys(object).find(key => object[key] === value);
    }

    static findValue(array, id){
        return array.find(value=>value.value === id)?.text;
    }

    static deepEqual(firstObject, secondObject) {
        return JSON.stringify(firstObject) === JSON.stringify(secondObject);
    }

    static entriesToObject(entries) {
        const result = {}
        for (const [key, value] of entries) { // each 'entry' is a [key, value] tupple
            result[key] = value;
        }
        return result;
    }

    static parseFieldOptions(groups) {
        if (!groups?.length) {
            return [];
        }
        return groups.map(group => {
            const { children, fields } = group;
            return [
                ...(children || []).map(child => {
                    const { fields: child_fields, label } = child;
                    return [
                        {
                            key: label,
                            text: label,
                            className: 'FieldCategory',
                            disabled: true,
                            header: true,
                            secondary_header: true,
                        },
                        ...child_fields?.map(child_field => {
                            const fieldOptions = child_field?.options || [];
                            const type = child_field.field_type;
                            const path = child_field.flatten_path
                            const options = (fieldOptions && fieldOptions.length > 0) ?
                                type === "dropdown" || type === "tagsinput" || type === "picklist" || type === "rating" || type === "radio" ?
                                    fieldOptions.map((option, id) => {
                                        return ({
                                            text: option.value,
                                            value: path === "person.phone.X.phone_type" || path === "person.email.X.email_type" ?
                                                (option.value?.toLowerCase() || "") :
                                                (option.id || id),
                                            key: option.id || id
                                        })
                                    }) || [] :
                                    type === "dependency" ?
                                        fieldOptions.map(parentOptions => ({
                                            key: parentOptions.id,
                                            value: parentOptions.id,
                                            text: parentOptions.value,
                                            options: (
                                                parentOptions?.sub_options?.map(type => ({
                                                    key: type.id,
                                                    value: type.id,
                                                    text: type.value
                                                })) || []
                                            )
                                        })) || []
                                        : false
                                : false;
                            return {
                                key: child_field.flatten_path,
                                value: child_field.flatten_path,
                                text: child_field.label,
                                className: 'FieldCategory__option',
                                field_type: type,
                                options,
                                parent: label,
                                multiple: !!child?.multiple
                            }
                        })
                    ]
                }).flat(),
                ...fields.map(field => {
                    const fieldOptions = field?.options || [];
                    const type = field.field_type;
                    const options = (fieldOptions && fieldOptions.length > 0) ?
                        type === "dropdown" || type === "tagsinput" || type === "picklist" || type === "rating" || type === "radio" ?
                            fieldOptions.map((option, id) => ({ text: option.value, value: option.id || id, key: option.id || id })) || [] :
                            type === "dependency" ?
                                fieldOptions.map(parentOptions => ({
                                    key: parentOptions.id,
                                    value: parentOptions.id,
                                    text: parentOptions.value,
                                    options: (
                                        parentOptions?.sub_options?.map(type => ({
                                            key: type.id,
                                            value: type.id,
                                            text: type.value
                                        })) || []
                                    )
                                })) || []
                                : false
                        : false;
                    return {
                        key: field.flatten_path,
                        value: field.flatten_path,
                        text: field.label,
                        field_type: type,
                        options,
                        className: 'Field__option',
                        multiple: !!group?.multiple
                    }
                })
            ]
        }).flat();
    }

    static parseCustomFieldOptions(groups) {
    if (!groups?.length) {
        return [];
    }

    const getFieldOptions = (field) => {
        const fieldOptions = field?.options || [];
        const type = field.field_type;
        const path = field.flatten_path;

        if (!fieldOptions.length) {
            return false;
        }

        if (["dropdown", "tagsinput", "picklist", "rating", "radio"].includes(type)) {
            return fieldOptions.map((option, id) => ({
                text: option.value,
                value:
                    path === "person.phone.X.phone_type" ||
                    path === "person.email.X.email_type"
                        ? (option.value?.toLowerCase() || "")
                        : (option.id || id),
                key: option.id || id,
            }));
        }

        if (type === "dependency") {
            return fieldOptions.map(parentOption => ({
                key: parentOption.id,
                value: parentOption.id,
                text: parentOption.value,
                options:
                    parentOption.sub_options?.map(option => ({
                        key: option.id,
                        value: option.id,
                        text: option.value,
                    })) || [],
            }));
        }

        return false;
    };

    const parseGroup = (group) => ({
        type: "flyout",
        key: group.id,
        text: group.label,
        children: [
            ...(group.children || []).map(parseGroup),
            ...(group.fields || []).map(field => ({
                key: field.flatten_path,
                value: field.flatten_path,
                text: field.label,
                field_type: field.field_type,
                options: getFieldOptions(field),
                multiple: !!group?.multiple
            }))
        ]
    });

    return groups.map(parseGroup);
}
    static formatFields(mapping_fields) {
        if (mapping_fields === null || mapping_fields === undefined) {
            return [];
        }
        const { contact, lead, opportunity, customer } = mapping_fields;
        const contact_standard_fields = this.parseFieldOptions(contact.standard);
        const lead_standard_fields = this.parseFieldOptions(lead?.standard);
        const opportunity_standard_fields = this.parseFieldOptions(opportunity?.standard);
        const customer_standard_fields = this.parseFieldOptions(customer?.standard);
        const contact_custom_fields = contact.custom ? this.parseFieldOptions([contact.custom]) : [];
        const lead_custom_fields = lead?.custom ? this.parseFieldOptions([lead?.custom]) : [];
        const opportunity_custom_fields = opportunity?.custom ? this.parseFieldOptions([opportunity?.custom]) : [];
        const customer_custom_fields = customer?.custom ? this.parseFieldOptions([customer?.custom]) : [];

        return [
            {
                key: 'Standard Fields',
                text: 'Standard Fields',
                disabled: true,
                className: 'FieldGroupClassification',
                primary_header: true
            },
            ...contact_standard_fields,
            ...lead_standard_fields,
            ...opportunity_standard_fields,
            ...customer_standard_fields,
            {
                key: 'Custom Fields',
                text: 'Custom Fields',
                disabled: true,
                className: 'FieldGroupClassification',
                primary_header: true
            },
            ...contact_custom_fields,
            ...lead_custom_fields,
            ...opportunity_custom_fields,
            ...customer_custom_fields,
        ];
    }

    static addMainField = (name, array) => {
        const headerIndex = array.findIndex(({header, text}) => header && text === name);
        array.splice(headerIndex + 1, 0, {
            key: `composite_${name.toLowerCase()}`,
            value: name.toLowerCase(),
            text: name,
            className: "FieldCategory__option",
            field_type: "composite",
            options: false,
            parent: name
        })
    }

    static extractCompositeFields(fields) {
        const phoneFields = [];
        const locationFields = [];
        const emailFields = [];
        const fieldsCopy = [];

        //TODO: Remove when CER-3999 is fixed
        for (let index = 0; index < fields.length; index++) {
            if (index === 0) {
                fieldsCopy.push(fields[0]);
                continue;
            }
            const isInCopy = fieldsCopy.find(({key}) => fields[index].key === key);
            if (!isInCopy) {
                fieldsCopy.push(fields[index]);
            }
        }
        
        const fieldOptions = fieldsCopy.filter((field) => {
            const { parent } = field;
            const isPhone = parent === "Phone";
            const isLocation = parent === "Location";
            const isEmail = parent === "Email";
            if (isPhone) {
                phoneFields.push(field);
            }
            if (isLocation) {
                locationFields.push(field);
            }
            if (isEmail) {
                emailFields.push(field);
            }
            return !isPhone && !isLocation && !isEmail;
        })
        this.addMainField("Phone", fieldOptions);
        this.addMainField("Location", fieldOptions);
        this.addMainField("Email", fieldOptions);
        return {
            fieldOptions,
            compositeFields: {
                phoneFields,
                locationFields,
                emailFields
            }
        }
    }

    static parseOptions(field) {
        const options = field?.options || [];

        if (!options?.length) {
            return false;
        }

        switch (field?.field_type) {
            case "dropdown":
            case "picklist":
            case "tagsinput":
            case "radio":
            case "rating":
                return options?.map?.((option, index) => ({
                    key: option?.id ?? index,
                    value:
                        field?.flatten_path === "person.phone.X.phone_type" ||
                            field?.flatten_path === "person.email.X.email_type"
                            ? option?.value?.toLowerCase()
                            : (option?.id ?? index),
                    text: option?.value,
                }));

            case "dependency":
                return options?.map?.((parent) => ({
                    key: parent?.id,
                    value: parent?.id,
                    text: parent?.value,
                    options:
                        parent?.sub_options?.map((child) => ({
                            key: child?.id,
                            value: child?.id,
                            text: child?.value,
                        })) || [],
                }));

            default:
                return false;
        }
    }

    static formatFieldsForDylSelect(mapping_fields) {
        if (!mapping_fields) return [];

        const headerProps = {
            disabled: true,
            className: "FieldGroupClassification",
            primary_header: true,
        };

        const STANDARD_FLYOUT_SECTIONS = new Set([
            "Phone",
            "Email",
            "Social Media",
            "Location",
        ]);

        const modules = [
            {
                label: "Contact Standard Fields",
                fields: this.parseFieldOptions(
                    mapping_fields?.contact?.standard,
                ),
            },
            {
                label: "Contact Custom Fields",
                fields: this.parseCustomFieldOptions(
                    mapping_fields?.contact?.custom?.children,
                ),
            },
            {
                label: "Lead Standard Fields",
                fields: this.parseFieldOptions(mapping_fields?.lead?.standard),
            },
            {
                label: "Lead Custom Fields",
                fields: this.parseCustomFieldOptions(
                    mapping_fields?.lead?.custom?.children,
                ),
            },
            {
                label: "Opportunity Standard Fields",
                fields: this.parseFieldOptions(
                    mapping_fields?.opportunity?.standard,
                ),
            },
            {
                label: "Opportunity Custom Fields",
                fields: this.parseCustomFieldOptions(
                    mapping_fields?.opportunity?.custom?.children,
                ),
            },
            {
                label: "Customer Standard Fields",
                fields: this.parseFieldOptions(
                    mapping_fields?.customer?.standard,
                ),
            },
            {
                label: "Customer Custom Fields",
                fields: this.parseCustomFieldOptions(
                    mapping_fields?.customer?.custom?.children,
                ),
            },
        ];

        return modules.flatMap(({ label, fields }) => {
            if (!fields?.length) {
                return [];
            }

            const formattedFields = [];

            for (let i = 0; i < fields.length; i++) {
                const field = fields[i];

                // Already a flyout (custom fields)
                if (field.type === "flyout") {
                    formattedFields.push(field);
                    continue;
                }

                // Convert Standard Data Enhancement sections into flyouts
                if (field.header && STANDARD_FLYOUT_SECTIONS.has(field.text)) {
                    const children = [];

                    let j = i + 1;

                    while (j < fields.length) {
                        const child = fields[j];

                        if (
                            child.primary_header ||
                            child.header ||
                            child.type === "flyout" ||
                            child.parent !== field.text
                        ) {
                            break;
                        }

                        const formattedChild = { ...child };

                        if (
                            Array.isArray(formattedChild.options) &&
                            formattedChild.options.length
                        ) {
                            formattedChild.type = "flyout";
                            formattedChild.children =
                                formattedChild.options.map((option) => ({
                                    key: option.key,
                                    value: option.value,
                                    text: option.text,
                                }));
                        }

                        children.push(formattedChild);
                        j++;
                    }

                    formattedFields.push({
                        type: "flyout",
                        key: field.key,
                        text: field.text,
                        children,
                    });

                    i = j - 1;
                    continue;
                }
                formattedFields.push({
                    ...field,
                    secondary_header: !field?.parent && !field?.children?.length,
                    standalone: !field?.parent && !field?.disabled,
                });
            }
            return [
                {
                    key: label,
                    text: label,
                    ...headerProps,
                },
                ...formattedFields,
            ];
        });
    }
}
